import React from 'react';

import classNames from 'classnames/bind';
import style from './MoreArticles.scss';
const ctx = classNames.bind(style);

import Slider from './blocks/Slider';
import List from './blocks/List';

const MoreArticles = props => (
  <div className={ctx('more-articles')}>
    <div className={ctx('title')}>Читайте далее:</div>
    <div className={ctx('articles--isMobile')}>
      <List {...props} />
    </div>
    <div className={ctx('articles--isDesktop')}>
      <Slider {...props} />
    </div>
  </div>
);

export default MoreArticles;
